module.exports = __webpack_public_path__ + "phone.694692b.png";